export default __webpack_public_path__ + "static/media/Animations_Clock6.6182f91d.svg";